module.exports = __webpack_public_path__ + "static/media/bottone_mail.7cff01b2.png";